import { apsEnums } from "../../shared/dto/aps.enums";
import * as angular from 'angular';
import template from "./fillOutCheckList.tpl.html";
import CheckListInstance, { CheckInstance } from "../../models/checkLists/checkListInstance";
import CheckListInstancesServiceName, { CheckListInstancesService } from "../../services/checkLists/checkListInstances.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import { StateParams } from "../../common";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import CheckListsServiceName, { CheckListsService } from "../../services/checkLists/checkLists.service";
import ShopServiceName, { ShopService } from "../../services/shops/shops.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import { Enums, BroadcastMessages } from "../../shared/config/constant.module";
import * as _ from "lodash";
import { apsCommands } from "../../shared/dto/aps.commands";
import * as moment from "moment"; // require("moment");
import LocationsServiceName, { LocationsService, PlantLocation } from "../../services/locations/locations.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import ToolChangeServiceName, { ToolChangeService } from "../../services/toolChange/toolChange.service";
import DefectTypeServiceName, { DefectTypesAndClassifications, DefectTypeService } from "../../services/defects/defectType.service";

let requires = [CheckListInstancesServiceName, NotifyServiceName, LoaderServiceName, CheckListsServiceName,
  ShopServiceName, AuthDataServiceName, LocationsServiceName, NavigationServiceName, ToolChangeServiceName,
  DefectTypeServiceName];

export interface FillOutCheckListCtrlParameters {
  checkListId: string;
  instanceId: string;
  plantId: string;
  tankId: string;
  shopId: string;
  readOnly?: boolean;
  itemStatusFilter?: apsEnums.CheckStatus;
  plantLocationId: string;
  scheduledOn?: Date;
  preview?: boolean;
}

export function openFillOutCheckList(
  data: FillOutCheckListCtrlParameters,
  $modal: mm.foundation.modal): angular.IPromise<apsCommands.FillOutCheckList> {

  return $modal.open({
    template: template,
    controller: 'FillOutCheckListCtrl as vm',
    resolve: {
      params: () => data
    }
  }).result;
}

class FillOutCheckListCtrl {
  instance: CheckListInstance;
  form: angular.IFormController;
  statusOptions: any[];
  timeZone: string;
  molds: apsViewModels.MachineMold[];

  private checkListInstancesService: CheckListInstancesService;
  private checkStatus = apsEnums.CheckStatus;
  private checkAdditionalData = apsEnums.CheckAdditionalData;
  private notifyService: NotifyService;
  private loaderService: LoaderService;
  private $modalInstance: mm.foundation.modalInstance;
  private $rootScope: angular.IRootScopeService;
  private authDataService: AuthDataService;
  shop: apsViewModels.ShopConfiguration;
  jobRun: apsViewModels.JobRunConfiguration;
  private plant: apsViewModels.PlantItem;
  private checkList: apsViewModels.CheckListItem;
  private readOnly: boolean;
  disabled: boolean;
  private plantLocationId: string;
  private plantId: string;
  private shopId: string;
  private userId: string;
  private scheduledOn: string;
  private instanceId: string;
  private $timeout: angular.ITimeoutService;
  private preview?: boolean;
  allDefectTypes?: DefectTypesAndClassifications;
  plantLocation: apsViewModels.LocationNavigation;

  constructor(
    checkListsService: CheckListsService,
    checkListInstancesService: CheckListInstancesService,
    shopService: ShopService,
    locationsService: LocationsService,
    navigationService: NavigationService,
    private toolChangeService: ToolChangeService,
    notifyService: NotifyService,
    loaderService: LoaderService,
    $modalInstance: mm.foundation.modalInstance,
    $q: angular.IQService,
    $rootScope: angular.IRootScopeService,
    params: FillOutCheckListCtrlParameters,
    $stateParams: StateParams,
    defectTypeService: DefectTypeService,
    authDataService: AuthDataService) {

    this.authDataService = authDataService;
    this.checkListInstancesService = checkListInstancesService;
    this.$rootScope = $rootScope;
    this.notifyService = notifyService;
    this.loaderService = loaderService;
    this.$modalInstance = $modalInstance;
    this.statusOptions = _.values(Enums.CHECK_STATUS);
    this.readOnly = params.readOnly;
    this.preview = params.preview;

    var checkListId = params.checkListId;
    var instanceId = params.instanceId;
    this.plantLocationId = params.plantLocationId;
    var scheduledOn = params.scheduledOn;

    this.plantId = params.plantId;
    this.shopId = $stateParams.shopId;
    this.scheduledOn = moment(params.scheduledOn).format("YYYY-MM-DDTHH:mm:ss");

    this.instanceId = params.instanceId;
    this.userId = $stateParams.userId;

    this.$modalInstance.result.catch((ex) => {
      this.cancel();
    });

    var promises = [];
    promises.push(shopService.getPlants()
      .then((plants: apsViewModels.PlantItem[]) => {
        this.plant = _.find(plants, { id: params.plantId });
        if (this.plant) {
          this.timeZone = this.plant.timeZoneId;
        }
      }));

    if (params.shopId) {
      promises.push(shopService.getShopConfiguration(params.shopId)
        .then(shop => {
          this.shop = shop;
        }));
    }

    if (params.plantLocationId) {
      promises.push(navigationService.getLocations(false)
        .then(locations => {
          this.plantLocation = _.find(locations, { id: params.plantLocationId });
        }));
    }

    promises.push(checkListsService.getCheckListToFillOut(checkListId, params.plantId, params.shopId)
      .then(checkList => {
        this.checkList = checkList;

        if (!checkList) {
          this.disabled = true;
        }
      }));

    var setJobRun = (date: Date) => {
      var time = date.getTime();
      this.jobRun = _.find(this.shop.jobRuns, (jr: apsViewModels.JobRunConfiguration) =>
        jr.startDate.getTime() <= time && (!jr.endDate || jr.endDate.getTime() > time));
    };

    promises.push(defectTypeService.getDefectTypesAndClassifications()
      .then(data => this.allDefectTypes = data));

    var loadAll = $q.all(promises)
      .then(() => {
        if (this.disabled) {
          return;
        }

        if (instanceId) {
          return this.checkListInstancesService.getCheckListInstance(instanceId, this.plantLocationId, scheduledOn)
            .then(instance => {
              var checkListInstance = new CheckListInstance(instance);
              checkListInstance.populateResults(this.checkList, this.plant, this.shop,
                this.authDataService);
              for (let previous of instance.previousCheckInstances) {
                let checks = checkListInstance.results.filter(x => x.checkId === previous.checkId);
                for (let check of checks) {
                  check.onChange(checkListInstance);
                }
              }

              if (!_.isUndefined(params.itemStatusFilter)) {
                checkListInstance.results = _.filter(checkListInstance.results, (c: CheckInstance) => {
                  return c.status === params.itemStatusFilter;
                });
              }

              if (checkListInstance.status >= apsEnums.CheckListStatus.Complete) {
                var roleLocation = authDataService.getSelectedRoleLocation();
                var roleId = roleLocation.role.roleId;
                if (!authDataService.isPlantAdmin(params.plantId)
                  && this.checkList.roleId !== roleId
                  && !_.includes(this.checkList.allowedRoles, roleId)) {
                  this.readOnly = true;
                }
              }

              this.preFillCheckStatus(checkListInstance);
              this.setDefectTypes(checkListInstance);

              this.instance = checkListInstance;

              setJobRun(instance.scheduledOn || new Date());
              this.getMolds();
            });
        } else if (!this.checkList.isScheduled || params.preview) {
          return checkListsService.getCheckListMandatory(this.checkList.id, params.plantId, params.shopId)
            .then(checkListMandatory => {
              var roleLocation = authDataService.getSelectedRoleLocation();
              var roleId = roleLocation.role.roleId;
              var checkListInstance = new CheckListInstance({
                id: null,
                checkListId: this.checkList.id,
                plantId: params.plantId,
                tankId: params.tankId,
                shopId: params.shopId,
                checkInstances: [],
                status: apsEnums.CheckListStatus.Pending,
                isMandatory: checkListMandatory ? checkListMandatory.isMandatory : false,
                scheduledOn: null,
                expiresOn: null,
                signedOff: false,
                signedOffById: null,
                signedOffOn: null,
                locationType: this.checkList.locationType,
                locationId: this.checkList.locationId,
                checkListIsGroup: false,
                checkListName: this.checkList.name,
                result: apsEnums.CheckListResult.Incomplete,
                hasFailures: false,
                roleId: roleId,
                plantLocationId: params.plantLocationId,
                previousCheckInstances: []
              });
              if (this.checkList.locationType !== apsEnums.LocationType.Tank
                && this.checkList.locationType !== apsEnums.LocationType.Shop) {
                checkListInstance.tankId = null;
                checkListInstance.shopId = null;
              } else if (this.checkList.locationType !== apsEnums.LocationType.Shop) {
                checkListInstance.shopId = null;
              }
              checkListInstance.populateResults(this.checkList, this.plant, this.shop,
                this.authDataService);
              this.preFillCheckStatus(checkListInstance);
              this.setDefectTypes(checkListInstance);
              this.instance = checkListInstance;
              setJobRun(new Date());
              this.getMolds();
            });
        } else {
          this.notifyService.error('Cannot create new instance of a scheduled check list');
          this.$modalInstance.close();
        }
      });

    this.loaderService.loadingPromise(loadAll);
  }

  private preFillCheckStatus(checkListInstance: CheckListInstance) {
    _.forEach(checkListInstance.results, (r: CheckInstance) => {   
      if (checkListInstance.status < apsEnums.CheckListStatus.Complete && !checkListInstance.isMandatory && !r.status) {
        r.status = apsEnums.CheckStatus.NotDone;
      }
    });
  }

  private getMolds() {
    if (!this.instance.shopId) {
      return;
    }

    if (this.instance.results.filter(x => x.checkItem.entry === apsEnums.CheckEntry.PerCavity).length === 0) {
      return;
    }

    this.toolChangeService.getToolMolds(this.instance.shopId, this.instance.scheduledOn || new Date())
      .then(molds => this.molds = molds);
  }

  calcTonnage(index: number) {
    let i = 0;
    let totalSeconds = 0;
    let ounces = 0.0;
    let totalPounds = 0.0;
    let totalOunces = 0.0;
    let totalTons = 0.0;
    let numberofrecords = this.instance.results.length;
    if (numberofrecords > 4) {
      _.forEach(this.instance.results, (r: CheckInstance) => {
        if (i === (2 - (index % 2))) {
          ounces = r.result;
        }
        if (i === (4 - (index % 2))) {
          totalSeconds = r.result * 60;
        }
        i++;
      });
      if (!isNaN(totalSeconds)) {

        totalOunces = (totalSeconds / 5) * ounces;
        totalPounds = totalOunces / 16;
        totalTons = totalPounds / 2000;
        i = 0;
        _.forEach(this.instance.results, (r: CheckInstance) => {
          if (i === (6 - (index % 2))) {
            r.result = totalTons.toFixed(2);
          }
          i++;
        });
      }
    } else {
      _.forEach(this.instance.results, (r: CheckInstance) => {
        if (i === 1) {
          ounces = r.result;
        }
        if (i === 2) {
          totalSeconds = r.result * 60;
        }
        i++;
      });
      if (!isNaN(totalSeconds)) {

        totalOunces = (totalSeconds / 5) * ounces;
        totalPounds = totalOunces / 16;
        totalTons = totalPounds / 2000;
        i = 0;
        _.forEach(this.instance.results, (r: CheckInstance) => {
          if (i === 3) {
            r.result = totalTons.toFixed(2);
          }
          i++;
        });
      }
    }
  }

  submit() {
    if (this.form.$invalid) {
      var invalidElement = angular.element('input.ng-invalid').first();
      if (invalidElement.length === 1) {
        var top = angular.element('body').scrollTop();
        var offset = invalidElement.offset();
        if (offset.top < (top - 50)) {
          angular.element('body').animate({ scrollTop: offset.top - 50 });
        }
        invalidElement.focus();
      }

      return;
    }

    if (_.some(this.instance.results, r => r.isStatusInvalid())) {
      return;
    }

    _.forEach(this.instance.results, (r: CheckInstance) => {
      r.prepareForSubmit();
      if (r.aggregateValues && r.aggregateValues.length > 0) {
        var check = r.check();
        if (check.valueType === apsEnums.CheckValueType.MultipleSample) {
          r.result = _.map(check.dimensions, d => r.aggregateResult(d)).join(',');
        } else {
          r.result = r.aggregateResult();
        }
      }
    });

    var command = _.clone(this.instance);

    command.results = _.filter(command.results, (x: CheckInstance) =>
      x.check().dataType !== apsEnums.CheckDataType.Instructions
    );

    if (_.some(command.results, { status: apsEnums.CheckStatus.NotDone })) {
      if (!confirm('There are incomplete checks. Do you want to submit?')) {
        return;
      }
    }

    if (this.preview) {
      this.$modalInstance.close();
      this.broadcastMessage(BroadcastMessages.FILL_OUT_CHECKLIST_CANCELLED, {});
      return;
    }

    // workaround for archived checklist instances missing this data
    if (command.plantId === '00000000-0000-0000-0000-000000000000' && this.plantLocation) {
      command.plantId = this.plantLocation.plantId;
      command.tankId = this.plantLocation.tankId;
      command.shopId = this.plantLocation.shopId;
      command.plantLocationId = this.plantLocation.id;
    }

    this.loaderService.loadingPromise(
      this.checkListInstancesService.saveCheckListInstance(command)
        .then(() => {
          this.notifyService.success('Check List Results Saved!');
          this.$modalInstance.close(command);
        }, this.notifyService.handleApiErrors)
    );
  }

  broadcastMessage(messageTitle, options) {
    this.$rootScope.$emit(messageTitle, options);
  }

  cancel() {
    this.$modalInstance.close();
    this.broadcastMessage(BroadcastMessages.FILL_OUT_CHECKLIST_CANCELLED, {});
  }

  setDefectTypes(checkListInstance: CheckListInstance) {
    if (!this.allDefectTypes) {
      return;
    }

    for (let checkInstance of checkListInstance.results) { 
      if (checkInstance.checkItem.dataType !== apsEnums.CheckDataType.DefectType) {
        checkInstance.defectTypes = [];
        continue;
      }
  
      let defectTypes = this.allDefectTypes.types;
      let severity = checkInstance.checkItem.defectTypeSeverity;
      if (severity !== null) {
        defectTypes = defectTypes.filter(x => x.severity === severity);
      }
      checkInstance.defectTypes = defectTypes.sort((x,y) => x.name.localeCompare(y.name));
    };
  }

  private updateStatus(
    checkInstance: CheckInstance,
    status: apsEnums.CheckStatus,
    index: number) {

    if (this.readOnly) { return; }

    let check = checkInstance.check();
    let isBoolean = (check.dataType === apsEnums.CheckDataType.Boolean);

    if (check && status === apsEnums.CheckStatus.NotApplicable && (check.name === '{streamingtime}' || check.name === '{shovelweight}')) {
      checkInstance.validationRangeMin = 0;
      checkInstance.result = 0;
    } else {
      checkInstance.validationRangeMin = check.rangeMin;
    }

    if (checkInstance.status === status) {
      if (check && status === apsEnums.CheckStatus.NotApplicable && (check.name === '{streamingtime}' || check.name === '{shovelweight}')) {
        checkInstance.validationRangeMin = check.rangeMin;
      }

      checkInstance.status = apsEnums.CheckStatus.NotDone;
      if (isBoolean) {
        checkInstance.result = null;
      }
    } else {
      checkInstance.status = status;
      if (isBoolean) {
        if (checkInstance.status === apsEnums.CheckStatus.NotApplicable) {
          checkInstance.result = 'N/A';
        } else if (check.booleanPass !== null) {
          if (checkInstance.status === apsEnums.CheckStatus.Passed) {
            checkInstance.result = check.booleanPass.toString();
          } else if (checkInstance.status === apsEnums.CheckStatus.Failed) {
            checkInstance.result = (!check.booleanPass).toString();
          }
        }
      }
    }
    if (this.checkList.name === 'Hourly Downtime') {
      this.calcTonnage(index);
    }

  }
}

export default angular.module('aps.controller.fillOutCheckList', requires)
  .controller('FillOutCheckListCtrl', FillOutCheckListCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/checks/fillOutCheckList.controller.ts